export const featureFlags = {
  additinalContactsRewrite: 'additinalContactsRewrite',
  borrowerDisableSmsLoginOption: 'borrowerDisableSmsLoginOption',
  callNotes: 'callNotes',
  callTranscription: 'callTranscription',
  caseEvents: 'caseEvents',
  chargeFeeTool: 'chargeFeeTool',
  crmCallHold: 'crmCallHold',
  crmCaseAssignment: 'crmCaseAssignment',
  dashboardTool: 'dashboardTool',
  draftEmailRewrite: 'draftEmailRewrite',
  draftMailRewrite: 'draftMailRewrite',
  draftTextRewrite: 'draftTextRewrite',
  drawFundsShowButton: 'drawFundsShowButton',
  enableTemplateEditing: 'enableTemplateEditing',
  interactionRewrite: 'interactionRewrite',
  issueRefundTool: 'issueRefundTool',
  loanLabels: 'loanLabels',
  manageAutopayRewrite: 'manageAutopayRewrite',
  manageCardStatus: 'manageCardStatus',
  manageRefundsTool: 'manageRefundsTool',
  objectChangedEvents: 'objectChangedEvents',
  pastMailRewrite: 'pastMailRewrite',
  paymentPlan: 'paymentPlan',
  summarizeCase: 'summarizeCase',
  supercaseEvents: 'supercaseEvents',
}
